import Vue from 'vue';
import {toggleButton, toggleTarget, toggleOpen, toggleArrow} from './toggleShow';

Vue.directive('toggle-button', toggleButton);
Vue.directive('toggle-target', toggleTarget);
Vue.directive('toggle-open'  , toggleOpen);
Vue.directive('toggle-arrow' , toggleArrow);
